import React, { ChangeEvent, useEffect, useState } from "react";
import ICatalogReconcileVendorsDTO from "../../../../models/DTO/ICatalogReconcileVendorsDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IOnCatalogReconcileVendorsDTO from "../../../../models/DTO/IOnCatalogReconcileVendorsDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./CatalogReconcileVendorLocations.scss";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

export const CatalogReconcileVendorLocations: React.FC<Props> = (props) => {
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [sourceCatalog, setSourceCatalog] = useState<ICatalog>();
    const [targetCatalog, setTargetCatalog] = useState<ICatalog>();
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.CatalogOnReconcileVendors, onReconcileVendors);
        props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, onGetCatalogs);
        props.socket.on(EndpointsEnum.Notify, notify);

        getCatalogs();

        return () => {
            props.socket.removeListener(EndpointsEnum.CatalogOnReconcileVendors, onReconcileVendors);
            props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, onGetCatalogs);
            props.socket.removeListener(EndpointsEnum.Notify, notify);
        };
    }, []);

    const notify = () => {};

    const reconcileVendors = () => {
        if (sourceCatalog && targetCatalog) {
            const payload: ICatalogReconcileVendorsDTO = {
                userGuid: props.userModel.guid,
                userToken: props.userModel.token,
                supplierGuid: props.supplierModel.guid,
                sourceCatalogGuid: sourceCatalog.guid,
                targetCatalogGuid: targetCatalog.guid,
            };

            props.socket.emit(EndpointsEnum.CatalogReconcileVendors, payload);

            setIsActive(true);
        }
    };

    const onReconcileVendors = (data: IOnCatalogReconcileVendorsDTO) => {
        const notification: INotification = {
            message: "successfully_reconciled_vendor_source_locations",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        setIsActive(false);
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            callMeta: {
                view: "CatalogReconcileVendorLocations",
                fn: "getCatalogs",
            },
        };

        props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const closeModal = () => {
        props.closeModalFn();
    };

    const selectCatalog = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        const catalogModel = catalogs.find((catalog) => catalog.guid === value);

        console.log(value);
        console.log(catalogModel);

        if (catalogModel) {
            if (name === "source") {
                setSourceCatalog(catalogModel);
            } else if (name === "target") {
                setTargetCatalog(catalogModel);
            }
        }
    };

    const submit = () => {
        reconcileVendors();
    };

    return (
        <div className={"CatalogReconcileVendorLocations p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"reconcile_vendor_source_locations"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"source_catalog"} />
                    <OwSelectOption
                        name={"source"}
                        fn={selectCatalog}
                        titleProp={"name"}
                        valueProp={"guid"}
                        selectedOption={sourceCatalog}
                        hasSelectedOptionProp={false}
                        options={catalogs}
                        emitTarget={true}
                    />
                </div>

                <div>
                    <OwLabel title={"target_catalog"} />
                    <OwSelectOption
                        name={"target"}
                        fn={selectCatalog}
                        titleProp={"name"}
                        valueProp={"guid"}
                        selectedOption={targetCatalog}
                        hasSelectedOptionProp={false}
                        options={catalogs}
                        emitTarget={true}
                    />
                </div>

                <div>
                    <OwButton title={"submit"} fn={submit} active={isActive} disableOnActive={true} />
                </div>
            </div>
        </div>
    );
};
